
import { defineComponent, ref, watch } from 'vue';
import DateFilter from '@/components/DateFilter.vue'; // Assuming DateFilter.vue is in this path

export default defineComponent({
  name: 'DateRangeFilter',
  components: {
    DateFilter,
  },
  emits: ['change'],
  setup(_, { emit }) {
    // DateFilter v-model expects an array: [startDate, endDate, type]
    // type can be like '7d', '30d', 'custom', etc.
    const selectedRange = ref<[string, string, string] | []>([]);

    const handleRangeUpdate = (newRange: [string, string, string] | []) => {
      if (newRange && newRange.length >= 2) {
        const startDate = newRange[0];
        const endDate = newRange[1];
        // Optionally, you could also pass up newRange[2] (the type) if needed
        emit('change', { startDate, endDate });
      } else {
        // Handle case where range is cleared or invalid
        emit('change', { startDate: null, endDate: null });
      }
    };

    // If you need to react to changes for other reasons, you can watch selectedRange
    // watch(selectedRange, (newVal) => {
    //   // This watcher might be redundant if handleRangeUpdate covers all emissions
    //   handleRangeUpdate(newVal);
    // });

    // To set an initial default value (e.g., last 7 days)
    // DateFilter uses specific string codes for its default ranges.
    // We would need to know the exact start/end dates for '7d' or set it via its internal logic.
    // For now, let DateFilter handle its own default or be initialized externally if needed.
    // Example if we knew the exact value DateFilter sets for '7d'
    // const today = new Date();
    // const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
    // selectedRange.value = [sevenDaysAgo.toISOString().split('T')[0], today.toISOString().split('T')[0], '7d'];

    return {
      selectedRange,
      handleRangeUpdate,
    };
  },
});
